import React from "react";
import { BOT_TYPES } from "./CampaignWizard.constants";

const BotTypeSelection = ({ selectedBotType, onSelect }) => {
  return (
    <div className="wizard-step-content">
      <h3 className="step-title">Select Bot Type</h3>
      <p className="step-subtitle">Choose the type of bot you want to create</p>
      <div className="bot-type-grid">
        {BOT_TYPES.map((bot) => {
          const Icon = bot.icon;
          const isSelected = selectedBotType === bot.id;
          return (
            <div
              key={bot.id}
              className={`bot-type-card-wizard ${isSelected ? "selected" : ""}`}
              onClick={() => onSelect(bot.id)}
              style={{ "--bot-color": bot.color }}
            >
              <div
                className="bot-type-card-icon"
                style={{ backgroundColor: `${bot.color}15`, color: bot.color }}
              >
                <Icon size={32} />
              </div>
              <h4 className="bot-type-card-title">{bot.label}</h4>
              <p className="bot-type-card-desc">{bot.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BotTypeSelection;
